/**
 * Согласие на участие в рейтинге Progress.
 *
 * По умолчанию человек в таблицах лидеров не показывается: участие
 * включается им самим и выключается тем же флажком (ТЗ SEC-06). Аналитика —
 * отдельное согласие, и о нём сказано отдельно: «согласие на всё сразу»
 * согласием не является.
 *
 * Флажок стоит одиночным — не вариантом выбора, а переключателем: рамка
 * группы вокруг единственного пункта обещает выбор, которого нет.
 */

import type { Translate } from '@type2x/i18n';

export interface ConsentToggleProps {
  readonly t: Translate;
  readonly consent: boolean;
  readonly onConsentChange: (optIn: boolean) => void;
}

export function ConsentToggle({
  t,
  consent,
  onConsentChange,
}: ConsentToggleProps): React.JSX.Element {
  return (
    <div className="t2x-consent">
      <label className="t2x-check">
        <input
          type="checkbox"
          checked={consent}
          onChange={(event) => onConsentChange(event.target.checked)}
        />
        <span>{t('leaderboard.consent')}</span>
      </label>
      <p className="t2x-muted">{t('leaderboard.consentHint')}</p>
      <p className="t2x-muted">{t('legal.analytics')}</p>
    </div>
  );
}
